// Computed-branch overrides — for questions whose routing depends on
// state.variables (scoring fan-outs, multi-variable predicates) and cannot
// be expressed by per-answer nextQuestionId in the CSV.
//
// Format: { questionId: (state) => nextQuestionId | null }
// Return null to terminate the quiz early (rare; usually the manifest
// terminal Q383024 handles this).
//
// Currently empty: Q383149 (leadership) and similar score branches are
// already expressed in the CSV (each answer routes differently per Likert
// score), so no override is needed. If we later discover a branch that
// depends on combinations of variables (e.g. "if leadershipScore + decisionScore
// both ≥ 4 → benchmark, else drill"), add an entry here and a unit test.

import type { QuizState } from '../store/quizStore';

export const COMPUTED_BRANCHES: Record<string, (state: QuizState) => string | null> = {
  // Example shape (commented):
  // '383XYZ': (state) => {
  //   const score = Number(state.variables.someScoreVar ?? 0);
  //   return score >= 4 ? '383ABC' : '383DEF';
  // },
};
